var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultValue, defined } from '../helpers';
import { saturate } from '../Math';
const MAX_IMG_SIZE = 2000;
export default class MediaImage {
    load(mediaItem) {
        return __awaiter(this, void 0, void 0, function* () {
            const imageLoaded = new Promise((resolve, reject) => {
                const image = new Image();
                image.crossOrigin = 'Anonymous';
                image.onload = () => resolve(image);
                image.onerror = () => reject();
                image.src = mediaItem.content;
            });
            const img = yield imageLoaded;
            this.canvas = resizeInCanvas(img);
            this.aspect = img.width / img.height;
            // Default to a fixed screen-space size which matches the image size, or scale based on a world-space size
            if (mediaItem.width > 0 || mediaItem.height > 0 || mediaItem.focus) {
                this.worldHeight = defaultValue(mediaItem.height, 200);
                if (defined(mediaItem.width))
                    this.worldHeight = mediaItem.width / this.aspect;
            }
        });
    }
    onReady(worldPos, context) {
        this.hudElement = context.hud.createElement('Image');
        this.hudElement.setCanvas(this.canvas);
        this.hudElement.setWorldPos(worldPos);
        this.hudElement.setWorldHeight(this.worldHeight);
    }
    destroy(context) {
        context.hud.removeElement(this.hudElement);
    }
}
const resizeInCanvas = img => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const scale = saturate(img.width > img.height ? MAX_IMG_SIZE / img.width : MAX_IMG_SIZE / img.height);
    canvas.width = Math.floor(img.width * scale);
    canvas.height = Math.floor(img.height * scale);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
};
